import {
  Alert,
  AppBar,
  Box,
  Button,
  DialogActions,
  IconButton,
  Paper,
  Snackbar,
  Stack,
  Toolbar,
  Typography,
  Grid
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { Portal } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import {
  DataGridPremium,
  GridCsvExportMenuItem,
  GridExcelExportMenuItem,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridToolbarFilterButton,
  gridFilteredSortedRowIdsSelector,
  useGridApiRef,
} from "@mui/x-data-grid-premium";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { v4 as uuidv4 } from "uuid";
import FieldNames from "../../../defaults/FieldNames.json";
import GridDefinitions from "../../../defaults/GridDefinitions.json";
import AuditLogService from "../../../services/AuditLogService";
import ErrorService from "../../../services/ErrorService";
import UserService from "../../../services/UserService";
import UserHelperService from "../../../services/UserHelperService";
import { getSuccessfulNewRoles, getUpdatedUserInfo, getUserRoles } from "../../../utils/AdminHelper";
import InFormGenericModal from "../../InFormGenericModal";
import AdminDialogAssignment from "../../userPopover/AdminDialogAssignment";
import AdminUserAssignment from "../../userPopover/AdminUserAssignment";
import { useDispatch } from "react-redux";
import { setShowMap } from "../../../redux/slices/displayStateSlice";

export default function UserAdminDialog({
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const config = useSelector((state) => state.configuration.config);
  const apiRef = useGridApiRef();
  const rootServiceUrl = useSelector(
    (state) => state.configuration.rootServiceUrl
  );
  const nifcToken = useSelector((state) => state.configuration.nifcToken);
  const headerHeight = useSelector((state) => state.displayState.headerHeight);
  const userInfo = useSelector((state) => state.globalContext.userInfo);
  
  
  const WhiteAlien = "#ffffff";
  const BlueAlien = "#1976d2";

  const useStyles = makeStyles({
    underline: {
      "&&&:before": {
        borderBottom: "2px solid red",
      },
      "&&:after": {
        borderBottom: "2px solid red",
      },
    },
    condensedFormControl: {
      margin: "5px 15px 5px 15px",
      minWidth: 120,
      width: "90%",
    },
    formControl: {
      margin: 15,
      minWidth: 120,
      width: "90%",
    },
    snackBarStyle: {
      top: "120px !important",
    }
  });

  const classes = useStyles();

  const [targetUser, setTargetUser] = useState(null);
  const [targetUserRoles, setTargetUserRoles] = useState(null);

  const [roleValues] = useState([
    { name: FieldNames.roles.local, code: FieldNames.roles.local },
    { name: FieldNames.roles.region, code: FieldNames.roles.region },
    { name: FieldNames.roles.agency, code: FieldNames.roles.agency },
    { name: FieldNames.roles.department, code: FieldNames.roles.department },
  ]);
  const [createdBy, setCreatedBy] = useState("");
  const [createdOn, setCreatedOn] = useState(""); //getSaveableDate(new Date());
  const [modifiedBy, setModifiedBy] = useState("");
  const [modifiedOn, setModifiedOn] = useState(""); //getSaveableDate(new Date());
  const [firstNameUpdate, setFirstNameUpdate] = useState("");
  const [lastNameUpdate, setLastNameUpdate] = useState("");
  const [emailUpdate, setEmailUpdate] = useState("");
  const [nifcUsernameUpdate, setNifcUsernameUpdate] = useState("");
  const [userIsAdminUpdate, setUserIsAdminUpdate] = useState(
    FieldNames.yesNo.no
  );
  const [userIsActiveUpdate, setUserIsActiveUpdate] = useState(
    FieldNames.yesNo.no
  );
  const [isTribalUserUpdate, setIsTribalUserUpdate] = useState(
    FieldNames.yesNo.no
  );
  const [userIsFuelsUpdate, setUserIsFuelsUpdate] = useState(
    FieldNames.yesNo.no
  );
  const [targetIdVal,setTargetIdVal] = useState(null);
  const [userObjectIDUpdate, setUserObjectIDUpdate] = useState(null);
  const [userIDUpdate, setUserIDUpdate] = useState("");
  const [roleUpdate, setRoleUpdate] = useState(null);
  const [nifcInputValue, setNifcInputValue] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isFailure, setIsFailure] = useState(false);
  const [selectedRoleUpdate, setSelectedRoleUpdate] = useState("");
  const [departmentSelectionUpdate, setDepartmentSelectionUpdate] =
    useState(null);
  const [agencySelectionUpdate, setAgencySelectionUpdate] = useState([]);
  const [regionSelectionUpdate, setRegionSelectionUpdate] = useState([]);
  const [unitSelectionUpdate, setUnitSelectionUpdate] = useState([]);
  const [tribeSelectionUpdate, setTribeSelectionUpdate] = useState({
    TribeFullName: "",
  });
  const [subUnitSelectionUpdate, setSubUnitSelectionUpdate] = useState([]);
  const [currentlyUsedRegionsUpdate, setCurrentlyUsedRegionsUpdate] = useState(
    []
  );
  const [currentlyUsedUnitsUpdate, setCurrentlyUsedUnitsUpdate] = useState([]);
  const [dbSavedUserRoles, setDbSavedUserRoles] = useState([]);
  const [openUserEdit, setOpenUserEdit] = useState(false);
  const [isUserDirty, setIsUserDirty] = useState(false);
  const [isUserRoleDirty, setIsUserRoleDirty] = useState(false);
  const [userIsPostFireUpdate, setUserIsPostFireUpdate] = useState(FieldNames.yesNo.no);
  const [userDefaultAppUpdate, setUserDefaultAppUpdate] = useState("");

  //const nifcToken = useSelector((state) => state.configuration.nifcToken);
  const [gridColumns, setGridColumns] = useState([]);
  const [gridRows, setGridRows] = useState([]);
  const userAdminGridColDefinitions = [
    GridDefinitions.UserAdminGrid.userName,
    GridDefinitions.UserAdminGrid.userId,
    GridDefinitions.UserAdminGrid.userRole,
    GridDefinitions.UserAdminGrid.agency,
    GridDefinitions.UserAdminGrid.region,
    GridDefinitions.UserAdminGrid.lastLogin,
  ];

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    Region: false,
  });

  const getDetailPanelContent = React.useCallback((row) => {
    return <UserGridDetailPanel row={row} />;
  }, []);

  const theme = createTheme({
    overrides: {
      MuiPaper: {
        root: {
          backgroundColor: "green",
        },
      },
      MuiOutlinedInput: {
        root: {
          "& $notchedOutline": {
            //initial border
            borderColor: BlueAlien,
          },
          "&:hover $notchedOutline": {
            //border on hover
            borderColor: BlueAlien,
            border: "2px solid",
          },
          "&$focused $notchedOutline": {
            //border on focus
            borderColor: BlueAlien,
            border: "2px solid",
          },
        },
      },
    },
  });

  useEffect(() => {
    dispatch(setShowMap(false));
  }, [dispatch]);

  useEffect(() => {
    if (targetUser) {
      setTargetIdVal(targetUser[FieldNames.userFields.id]);
      setUserIDUpdate(targetUser[FieldNames.userFields.userID]);
      setUserObjectIDUpdate(targetUser[FieldNames.userFields.objectID]);
      setEmailUpdate(targetUser[FieldNames.userFields.email]);
      setFirstNameUpdate(targetUser[FieldNames.userFields.firstName]);
      setLastNameUpdate(targetUser[FieldNames.userFields.lastName]);
      setNifcUsernameUpdate(targetUser[FieldNames.userFields.nifcUsername]);
      setUserIsAdminUpdate(targetUser[FieldNames.userFields.isAdmin]);
      setUserIsActiveUpdate(targetUser[FieldNames.userFields.isActive]);
      setUserIsFuelsUpdate(targetUser[FieldNames.userFields.isFuels]);
      setUserIsPostFireUpdate(targetUser[FieldNames.userFields.isPostFire]);
      setCreatedBy(targetUser[FieldNames.userFields.createdBy]);
      setCreatedOn(targetUser[FieldNames.userFields.createdOnDate]
      );
      setModifiedBy(targetUser[FieldNames.userFields.lastModifiedBy]);
      setModifiedOn(targetUser[FieldNames.userFields.lastModifiedDate]
      );
      const isTribal =
        targetUser[FieldNames.userFields.isTribalUser] ===
          FieldNames.yesNo.no ||
        targetUser[FieldNames.userFields.isTribalUser] === FieldNames.yesNo.yes
          ? targetUser[FieldNames.userFields.isTribalUser]
          : FieldNames.yesNo.no;
      setIsTribalUserUpdate(isTribal);

      let currentRole = roleValues.filter(
        (x) => x.code === targetUser[FieldNames.userFields.approvalRole]
      );
      if (currentRole && currentRole.length > 0) {
        setSelectedRoleUpdate(currentRole[0].name);
        setRoleUpdate(currentRole[0]);
      } else {
        setSelectedRoleUpdate("");
        setRoleUpdate(null);
      }
    }

    if (targetUserRoles && targetUserRoles.length > 0) {
      setDbSavedUserRoles(targetUserRoles);
      //They will all have the same role
      const savedRole = {
        name: `${targetUserRoles[0][FieldNames.userRoles.appRole]}`,
        code: `${targetUserRoles[0][FieldNames.userRoles.appRole]}`,
      };
      setRoleUpdate(savedRole);
      setSelectedRoleUpdate(`${targetUserRoles[0][FieldNames.userRoles.appRole]}`);
      setDepartmentSelectionUpdate({
        Department: targetUserRoles[0][FieldNames.userRoles.department],
      });

      let savedRegions = [];
      let savedUnits = [];
      let usedRegions = [];
      let usedUnits = [];
      let savedSubUnits = [];
      let savedAgencies = [];
      let savedTribes;
      
      // Collect unique region, unit, subunit, and agency names from saved roles
      let regionNames = [];
      let unitNames = [];
      let subUnitNames = [];
      let agencyNames = [];
      
      targetUserRoles.forEach((savedUserRole) => {
          if (savedUserRole) {
              if (savedUserRole[FieldNames.userRoles.agency]) {
                  const currentSavedAgencies = savedAgencies.map(
                      (x) => x[FieldNames.userRoles.agency]
                  );
                  if (
                      currentSavedAgencies &&
                      !currentSavedAgencies.includes(savedUserRole[FieldNames.userRoles.agency])
                  ) {
                      savedAgencies.push({
                          Agency: `${savedUserRole[FieldNames.userRoles.agency]}`,
                      });
                      agencyNames.push(savedUserRole[FieldNames.userRoles.agency]);
                  }
              }

              // Build complete region objects with Agency field from saved roles
              if (savedUserRole[FieldNames.userRoles.region]) {
                  if (!regionNames.includes(savedUserRole[FieldNames.userRoles.region])) {
                      regionNames.push(savedUserRole[FieldNames.userRoles.region]);
                      savedRegions.push({
                          Region: savedUserRole[FieldNames.userRoles.region],
                          Agency: savedUserRole[FieldNames.userRoles.agency]
                      });
                  }
              }

              // Build complete unit objects with Agency field from saved roles
              if (savedUserRole[FieldNames.userRoles.unit]) {
                  if (!unitNames.includes(savedUserRole[FieldNames.userRoles.unit])) {
                      unitNames.push(savedUserRole[FieldNames.userRoles.unit]);
                      savedUnits.push({
                          Unit: savedUserRole[FieldNames.userRoles.unit],
                          Agency: savedUserRole[FieldNames.userRoles.agency]
                      });
                  }
              }

              // Build complete subunit objects with Agency field from saved roles
              if (savedUserRole[FieldNames.userRoles.subUnit]) {
                  if (!subUnitNames.includes(savedUserRole[FieldNames.userRoles.subUnit])) {
                      subUnitNames.push(savedUserRole[FieldNames.userRoles.subUnit]);
                      savedSubUnits.push({
                          SubUnit: savedUserRole[FieldNames.userRoles.subUnit],
                          Agency: savedUserRole[FieldNames.userRoles.agency]
                      });
                  }
              }

              if (savedUserRole[FieldNames.userRoles.tribe]) {
                  savedTribes = {
                      TribeFullName: `${savedUserRole[FieldNames.userRoles.tribe]}`,
                  };
                  if (savedUserRole[FieldNames.userRoles.unit]) {
                      usedUnits.push(savedUserRole[FieldNames.userRoles.unit]);
                  }
              }

              if (
                  savedUserRole[FieldNames.userRoles.region] &&
                  savedUserRole[FieldNames.userRoles.unit]
              ) {
                  usedRegions.push(savedUserRole[FieldNames.userRoles.region]);
              }

              if (
                  savedUserRole[FieldNames.userRoles.unit] &&
                  savedUserRole[FieldNames.userRoles.subUnit]
              ) {
                  usedUnits.push(savedUserRole[FieldNames.userRoles.unit]);
              }
          }
      });
      
      // Set state immediately with data from targetUserRoles (which already has Agency field)
      setRegionSelectionUpdate(savedRegions);
      setUnitSelectionUpdate(savedUnits);
      setAgencySelectionUpdate(savedAgencies);
      setSubUnitSelectionUpdate(savedSubUnits);
      setTribeSelectionUpdate(savedTribes);
      setCurrentlyUsedRegionsUpdate(usedRegions);
      setCurrentlyUsedUnitsUpdate(usedUnits);
    }
  }, [targetUser, targetUserRoles]);

  useEffect(() => {
    establishGridColumns();
    UserService.getAllUsersAndRoles(rootServiceUrl, config).then((response) => {
      setGridRows(response);
    }).catch(error => {
      ErrorService.addErrorLogEntry(error);
    });
  }, [config, rootServiceUrl]);

  const establishGridColumns = () => {
    let columns = [];
    userAdminGridColDefinitions.forEach((colDef) => {
      columns.push({
        field: colDef.value,
        headerName: colDef.header,
        type: colDef.type,
        hideable: colDef.hideable,
        sortable: colDef.sortable,
        editable: colDef.editable,
        flex: colDef.flex,
        align: colDef.align,
        disableExport: colDef.disableExport,
        valueGetter: (value) => {
          return value; // Used for formatting string values I.E. currency formatting
        },
      });
    });

    columns.push({
      field: "actions",
      headerName: "Actions",
      hideable: true,
      sortable: false,
      editable: false,
      flex: 0.75,
      align: "center",
      disableExport: true,
      // Render Cell allows you to set entire components within a cell for custom buttons/functionality
      renderCell: (params) => {
        return params.rowNode.type === "group" ? null : (
          <Button onClick={(e) => editUser(e, params.row)} variant="outlined">
            Edit
          </Button>
        );
      },
    });

    setGridColumns(columns);
  };

  const editUser = (e, row) => {
    UserService.getUserByNifcUsername(
      rootServiceUrl,
      row.NifcUsername,
      config
    ).then(async(response) => {
      if (response && response.length > 0) {
        setTargetUser(response[0]);
        if (response[0]) {
          try
          {
            await UserService.getUserRoles(
              rootServiceUrl,
              response[0][FieldNames.userFields.id],
              config
            ).then((userRoles) => {
              if (userRoles && userRoles.length > 0) {
                setTargetUserRoles(userRoles);
                setOpenUserEdit(true);
              } else {
                setTargetUserRoles([]);
                setOpenUserEdit(true);
              }
            });
          }
          catch(error)
          {
            ErrorService.addErrorLogEntry(error);
          }
        }
      }
    }).catch(error => {
      ErrorService.addErrorLogEntry(error);
    });
  };

  const handleClearUpdateUser = () => {
    setUserIDUpdate("");
    setTargetIdVal(null);
    setUserObjectIDUpdate(null);
    setEmailUpdate("");
    setFirstNameUpdate("");
    setLastNameUpdate("");
    setNifcUsernameUpdate("");
    setUserIsAdminUpdate(FieldNames.yesNo.no);
    setUserIsFuelsUpdate(FieldNames.yesNo.no);
    setUserIsPostFireUpdate(FieldNames.yesNo.no);
    setUserDefaultAppUpdate("");
    setUserIsActiveUpdate(FieldNames.yesNo.no);
    setIsTribalUserUpdate(FieldNames.yesNo.no);
    setRoleUpdate(null);
    setSelectedRoleUpdate("");
    setNifcInputValue("");
    setUnitSelectionUpdate([]);
    setTribeSelectionUpdate({ TribeFullName: "" });
    setSubUnitSelectionUpdate([]);
    setRegionSelectionUpdate([]);
    setAgencySelectionUpdate([]);
    setDepartmentSelectionUpdate({ Department: FieldNames.defaults.department });
    setOpenUserEdit(false);
  };

  const handleSaveUpdateUser = async() => {
    let updatedUserInfo = getUpdatedUserInfo(userIDUpdate, uuidv4(), userInfo, setModifiedBy, setModifiedOn, setCreatedBy, setCreatedOn, createdBy,
      firstNameUpdate, lastNameUpdate, emailUpdate, nifcUsernameUpdate, userIsActiveUpdate, userIsAdminUpdate, userIsFuelsUpdate, 
      userIsPostFireUpdate, userDefaultAppUpdate, userObjectIDUpdate, isTribalUserUpdate, createdOn, targetIdVal)

      let newUserID = updatedUserInfo[FieldNames.userFields.userID];
      
    if(isUserDirty || isUserRoleDirty){
      UserService.updateUser(rootServiceUrl, nifcToken, updatedUserInfo, config).then(async response => {
        try
        {
          if(response && response.updateResults && response.updateResults[0].success){
            if(dbSavedUserRoles && dbSavedUserRoles.length > 0 && isUserRoleDirty){
              await savingUserRoles(true, targetIdVal, newUserID, dbSavedUserRoles, isUserDirty, response.updateResults[0].success);
            } else {
              await savingUserRoles(true, targetIdVal, newUserID, null, isUserDirty, response.updateResults[0].success);
            }
            
          } else {
            if(dbSavedUserRoles && dbSavedUserRoles.length > 0 && isUserRoleDirty){
              await savingUserRoles(true, targetIdVal, newUserID, dbSavedUserRoles, isUserDirty, false);
            } else {
              await savingUserRoles(true, targetIdVal, newUserID, null, isUserDirty, false);
            }
            setIsFailure(true);
            setSnackbarMessage("User update failed!");
            setSnackbarOpen(true);
          }
        }
        catch(error)
        {
          ErrorService.addErrorLogEntry(error);
        }
      })
    } else {
      try
      {
        //Only save User Roles if a user role field has changed
        if(dbSavedUserRoles && dbSavedUserRoles.length > 0 && isUserRoleDirty){
          await savingUserRoles(true, targetIdVal, newUserID, dbSavedUserRoles, isUserDirty, false);
        } else {
          await savingUserRoles(true, targetIdVal, newUserID, null, isUserDirty, false);
        }
      }
      catch(error)
      {
        ErrorService.addErrorLogEntry(error);
      }
    }
  };

  const savingUserRoles = async(isUpdate, idVal, newUserID, dbSavedUserRoles, isUserDirty, isUserSuccess) => {
    let userRoles;
    if(isUpdate){
      try
      {
        userRoles = await getUserRoles(rootServiceUrl, config, idVal, newUserID, departmentSelectionUpdate, agencySelectionUpdate, regionSelectionUpdate, 
          unitSelectionUpdate, roleUpdate, selectedRoleUpdate, subUnitSelectionUpdate, tribeSelectionUpdate)
      }
      catch(error)
      {
        ErrorService.addErrorLogEntry(error, "SYSTEM");
      }
    } 
    addUserRoles(userRoles, isUpdate, dbSavedUserRoles, isUserDirty, isUserSuccess);
  }
  
  const addAuditLog = (isUserDirty, isUserSuccess, isUserRoleDirty, isUserRoleSuccess) => {
    const user = {
      [FieldNames.featureFields.id]: targetIdVal,
      [FieldNames.featureFields.objectID]: userObjectIDUpdate
    }
    if(isUserDirty && isUserSuccess && isUserRoleDirty && isUserRoleSuccess){
      //Add audit log entry - not stack so that even if this call fails the others will continue
      AuditLogService.addAuditLogEntry(
          user,
          targetIdVal,
          FieldNames.auditLogJoinTypes.users,
          userInfo[FieldNames.userFields.nifcUsername],
          ['User was modified', 'User Role was modified']
      ).then((response) => {
          //getUserAuditLog(userObjectIDUpdate);
          setIsUserDirty(false);
          setIsUserRoleDirty(false);
      });
    } else {
      if(isUserDirty && isUserSuccess){
        //Add audit log entry - not stack so that even if this call fails the others will continue
        AuditLogService.addAuditLogEntry(user, targetIdVal, FieldNames.auditLogJoinTypes.users, userInfo[FieldNames.userFields.nifcUsername],
          ["User was modified"]).then(response => {
            //getUserAuditLog(userObjectIDUpdate);
            setIsUserDirty(false);
          });
      } else if (isUserRoleDirty && isUserRoleSuccess){
        //Add audit log entry - not stack so that even if this call fails the others will continue
        AuditLogService.addAuditLogEntry(
            user,
            targetIdVal,
            FieldNames.auditLogJoinTypes.users,
            userInfo[FieldNames.userFields.nifcUsername],
            ['User Role was modified']
        ).then((response) => {
            //getUser(userObjectIDUpdate);
            setIsUserRoleDirty(false);
        });
      }
    }
  }

  const addUserRoles = (allUserRoles, isUpdate, rolesToRemove, isUserDirty, isUserSuccess) => {
    if (allUserRoles && allUserRoles.length > 0) {
      UserService.addUserRoles(
        rootServiceUrl,
        nifcToken,
        allUserRoles,
        config
      ).then((roles) => {
        if(roles && roles.addResults && roles.addResults.length){
          let atLeastOneSuccess = false;
          let allSuccessfulNewRoles = getSuccessfulNewRoles(roles.addResults, allUserRoles);
          if(allSuccessfulNewRoles && allSuccessfulNewRoles.length){
            atLeastOneSuccess = true;
          }

          if(atLeastOneSuccess){
            //Once we successfully added new roles remove the old user roles before resetting the user roles for this user
            if(rolesToRemove && rolesToRemove.length > 0){
              UserService.deleteUsersRoles(rootServiceUrl, nifcToken, rolesToRemove, config).then((deleteResp) => {
                if(deleteResp && deleteResp.success){
                  if(allSuccessfulNewRoles && allSuccessfulNewRoles.length > 0){
                    setDbSavedUserRoles(allSuccessfulNewRoles);
                  } else {
                    setDbSavedUserRoles([]);
                  }
                  UserService.getAllUsersAndRoles(rootServiceUrl, config).then((response) => {
                    setGridRows(response);
                  });
                }
              });
            } else {
              if(allSuccessfulNewRoles && allSuccessfulNewRoles.length > 0){
                setDbSavedUserRoles(allSuccessfulNewRoles);
              } else {
                setDbSavedUserRoles([]);
              }
              UserService.getAllUsersAndRoles(rootServiceUrl, config).then((response) => {
                setGridRows(response);
              });
            }

            if(isUpdate){
              if(isUserSuccess && atLeastOneSuccess){
                setSnackbarMessage("User and User Roles updated successfully.");
              } else {
                if(isUserSuccess){
                  setSnackbarMessage("User updated successfully.");
                } else if(atLeastOneSuccess){
                  setSnackbarMessage("User Roles updated successfully.");
                }
              }
            }
            setIsFailure(false);
            setSnackbarOpen(true);
            addAuditLog(isUserDirty, isUserSuccess, isUserRoleDirty, true);
          }
        } else {
          setIsFailure(true);
          if(isUpdate){
            setSnackbarMessage("User updated successfully. User Roles update failed");
          }
          setSnackbarOpen(true);
          addAuditLog(isUserDirty, isUserSuccess, isUserRoleDirty, false);
        }
      }).catch(error => {
        ErrorService.addErrorLogEntry(error);
      });
    } else {
      // Handle case where no new roles to add, but may have old roles to remove
      if(rolesToRemove && rolesToRemove.length > 0 && isUserRoleDirty){
        UserService.deleteUsersRoles(rootServiceUrl, nifcToken, rolesToRemove, config).then((deleteResp) => {
          if(deleteResp && deleteResp.success){
            setDbSavedUserRoles([]);
            setIsFailure(false);
            if(isUpdate){
              setSnackbarMessage("User updated successfully. User roles removed.");
            }
            setSnackbarOpen(true);
            addAuditLog(isUserDirty, isUserSuccess, isUserRoleDirty, true);
            UserService.getAllUsersAndRoles(rootServiceUrl, config).then((response) => {
              setGridRows(response);
            }).catch(error => {
              ErrorService.addErrorLogEntry(error);
            });
          } else {
            setIsFailure(true);
            setSnackbarMessage("Failed to remove old user roles.");
            setSnackbarOpen(true);
            addAuditLog(isUserDirty, isUserSuccess, isUserRoleDirty, false);
          }
        }).catch(error => {
          ErrorService.addErrorLogEntry(error);
          setIsFailure(true);
          setSnackbarMessage("Failed to remove old user roles.");
          setSnackbarOpen(true);
        });
      } else {
        addAuditLog(isUserDirty, isUserSuccess, false, false);
        if(!isUserSuccess){
          setIsFailure(true);
          if(isUpdate){
            setSnackbarMessage("User update failed!");
          } else {
            setSnackbarMessage("User create failed!");
          }
          setSnackbarOpen(true);
        } else {
          setIsFailure(false);
          if(isUpdate){
            setSnackbarMessage("User updated successfully.");
          }
          setSnackbarOpen(true);
        }
        UserService.getAllUsersAndRoles(rootServiceUrl, config).then((response) => {
          setGridRows(response);
        }).catch(error => {
          ErrorService.addErrorLogEntry(error);
        });
      }
    }
  };

  const handleClose = () => {
    dispatch(setShowMap(true));
    navigate("/home");
  };

  // --- Grid Logic ---

  const exportOptions = {
    getRowsToExport: () => gridFilteredSortedRowIdsSelector(apiRef),
  };

  function CustomExportContainer(props) {
    return (
      <GridToolbarExportContainer {...props}>
        <GridCsvExportMenuItem
          options={exportOptions}
          onClick={() => apiRef.current.exportDataAsCsv(exportOptions)}
        />
        <GridExcelExportMenuItem
          options={exportOptions}
          onClick={() => apiRef.current.exportDataAsExcel(exportOptions)}
        />
      </GridToolbarExportContainer>
    );
  }

  function CustomUserGridToolbar(props) {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <CustomExportContainer />
      </GridToolbarContainer>
    );
  }

  return (
    <Box>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: BlueAlien, marginTop: headerHeight }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon style={{ fill: WhiteAlien }} />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1 }}
            variant="h6"
            component="div"
            style={{ color: WhiteAlien }}
          >
            User Administration
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          height: "500px",
          width: "100%",
          minWidth: "10px",
        }}
      >
        <DataGridPremium
            showToolbar
          apiRef={apiRef}
          getRowId={(row) => row[FieldNames.userFields.objectID]}
          rows={gridRows}
          columns={gridColumns}
          slots={{
            Toolbar: CustomUserGridToolbar,
          }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          getDetailPanelHeight={({ row }) => "auto"} // Height based on the content.
          getDetailPanelContent={({ row }) => getDetailPanelContent(row)}
        />
        <InFormGenericModal
          openFlag={openUserEdit}
          closeMethod={handleClearUpdateUser}
          titleText={"Edit User"}
          displayButton={false}
        >
          <Box
            style={{
              maxHeight: "75vh",
              overflow: "auto",
              maxWidth: "50vw",
              minWidth: "50vw",
            }}
          >
            <Paper elevation={6} style={{ padding: 20, margin: 20 }}>
              <h2>Update User</h2>
              <AdminUserAssignment isCreate={false} allUsers={null} setUserID={setUserIDUpdate} setIsUserDirty={setIsUserDirty} userID={userIDUpdate} setFirstName={setFirstNameUpdate} firstName={firstNameUpdate}
              setLastName={setLastNameUpdate} lastName={lastNameUpdate} setEmail={setEmailUpdate} email={emailUpdate} setNifcUsername={setNifcUsernameUpdate} nifcUsername={nifcUsernameUpdate} 
              userIsAdmin={userIsAdminUpdate} setUserIsAdmin={setUserIsAdminUpdate} userIsActive={userIsActiveUpdate} setUserIsActive={setUserIsActiveUpdate} userIsFuels={userIsFuelsUpdate} 
              setUserIsFuels={setUserIsFuelsUpdate} userIsPostFire={userIsPostFireUpdate} setUserIsPostFire={setUserIsPostFireUpdate} isTribalUser={isTribalUserUpdate} 
              setIsTribalUser={setIsTribalUserUpdate} setRole={setRoleUpdate} setSelectedRole={setSelectedRoleUpdate} setAgencySelection={setAgencySelectionUpdate} isNifcAlreadyUsed={false} 
              setIsNifcAlreadyUsed={null} />
              <AdminDialogAssignment
                role={roleUpdate}
                setRole={setRoleUpdate}
                selectedRole={selectedRoleUpdate}
                setSelectedRole={setSelectedRoleUpdate}
                departmentSelection={departmentSelectionUpdate}
                setDepartmentSelection={setDepartmentSelectionUpdate}
                agencySelection={agencySelectionUpdate}
                setAgencySelection={setAgencySelectionUpdate}
                regionSelection={regionSelectionUpdate}
                setRegionSelection={setRegionSelectionUpdate}
                unitSelection={unitSelectionUpdate}
                setUnitSelection={setUnitSelectionUpdate}
                subUnitSelection={subUnitSelectionUpdate}
                setSubUnitSelection={setSubUnitSelectionUpdate}
                currentlyUsedRegions={currentlyUsedRegionsUpdate}
                setCurrentlyUsedRegions={setCurrentlyUsedRegionsUpdate}
                currentlyUsedUnits={currentlyUsedUnitsUpdate}
                setCurrentlyUsedUnits={setCurrentlyUsedUnitsUpdate}
                roleOptions={roleValues}
                isTribalUser={isTribalUserUpdate}
                setIsTribalUser={setIsTribalUserUpdate}
                tribeSelection={tribeSelectionUpdate}
                setTribeSelection={setTribeSelectionUpdate}
                setIsUserRoleDirty={setIsUserRoleDirty}
              />
              <DialogActions>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ marginTop: "10px", marginRight: "15px", width: 100 }}
                  onClick={handleSaveUpdateUser}
                >
                  Save
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  style={{
                    marginTop: "10px",
                    marginLeft: "15px",
                    marginRight: "15px",
                    width: 100,
                  }}
                  onClick={handleClearUpdateUser}
                >
                  Close
                </Button>
              </DialogActions>
            </Paper>
          </Box>
        </InFormGenericModal>
        <ThemeProvider theme={theme}>
          <Portal>
            <Snackbar
              open={snackbarOpen}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              className={classes.snackBarStyle}
              onClose={() => {
                setSnackbarOpen(false);
                setSnackbarMessage("");
              }}
            >
              <Alert
                onClose={() => {
                  setSnackbarOpen(false);
                  setSnackbarMessage("");
                }}
                severity={isFailure ? "error" : "success"}
                sx={{ width: "100%" }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>
          </Portal>
        </ThemeProvider>
      </Box>
    </Box>
  );
}

function UserGridDetailPanel({ row: rowProp }) {
  if (!rowProp) {
    return null;
  }

  return (
    <Stack
      sx={{ py: 2, height: "100%", boxSizing: "border-box" }}
      direction="column"
    >
      <Paper sx={{ flex: 1, mx: "auto", width: "90%", p: 1 }}>
        <Stack direction="column" spacing={1} sx={{ height: 1 }}>
          <Grid container>
            <Grid item md={4}>
              <Typography variant="h5" fontWeight={"fontWeightBold"}>
                User Name
              </Typography>
              <Typography variant="body1">
                {rowProp[FieldNames.userFields.nifcUsername]}
              </Typography>
              &nbsp;
              <Typography variant="h5" fontWeight={"fontWeightBold"}>
                User Role
              </Typography>
              <Typography variant="body1">
                {rowProp[FieldNames.userRoles.appRole]}
              </Typography>
            </Grid>
            <Grid item md={4}>
              <Typography variant="h5" fontWeight={"fontWeightBold"}>
                User ID
              </Typography>
              <Typography variant="body1">
                {rowProp[FieldNames.userFields.userID]}
              </Typography>
              &nbsp;
              <Typography variant="h5" fontWeight={"fontWeightBold"}>
                Agency
              </Typography>
              <Typography variant="body1">
                {rowProp[FieldNames.userRoles.agency]}
              </Typography>
            </Grid>
            <Grid item md={4}>
              <Typography variant="h5" fontWeight={"fontWeightBold"}>
                Last Login
              </Typography>
              <Typography variant="body1">
                {rowProp[FieldNames.userFields.lastLogin]}
              </Typography>
              &nbsp;
              <Typography variant="h5" fontWeight={"fontWeightBold"}>
                Region
              </Typography>
              <Typography variant="body1">
                {rowProp[FieldNames.userRoles.region]}
              </Typography>
            </Grid>
          </Grid>
        </Stack>
      </Paper>
    </Stack>
  );
}
